/** Starter slot definitions aligned with Team Management / scoreboard. */

function num(v, defaultVal) {
  const n = Number(v);
  return Number.isFinite(n) ? n : defaultVal;
}

function pushPositionSlots(slots, prefix, labelPrefix, count, eligible, rowTint = null) {
  const n = Math.max(0, Math.floor(count));
  if (n <= 0) return;
  if (n === 1) {
    slots.push({ key: prefix, label: labelPrefix, eligible, rowTint });
    return;
  }
  for (let i = 1; i <= n; i++) {
    slots.push({
      key: `${prefix}${i}`,
      label: `${labelPrefix}${i}`,
      eligible,
      rowTint,
    });
  }
}

/**
 * @param {object} settings camelCase or snake_case from API
 * @returns {{ key: string, label: string, eligible: string[], rowTint?: 'silver' | 'gold' | null }[]}
 */
export function getStarterSlotDefinitions(settings) {
  const qbCount = num(settings?.qbCount ?? settings?.qb_count, 1);
  const rbCount = num(settings?.rbCount ?? settings?.rb_count, 2);
  const wrCount = num(settings?.wrCount ?? settings?.wr_count, 2);
  const teCount = num(settings?.teCount ?? settings?.te_count, 1);
  const flexCount = num(settings?.flexCount ?? settings?.flex_count, 1);
  const kCount = num(settings?.kCount ?? settings?.k_count, 0);
  const flexSilver = num(settings?.flexSilverCount ?? settings?.flex_silver_count, 0);
  const flexGold = num(settings?.flexGoldCount ?? settings?.flex_gold_count, 0);

  const slots = [];
  pushPositionSlots(slots, "QB", "QB", qbCount, ["QB"]);
  pushPositionSlots(slots, "RB", "RB", rbCount, ["RB"]);
  pushPositionSlots(slots, "WR", "WR", wrCount, ["WR"]);
  pushPositionSlots(slots, "TE", "TE", teCount, ["TE"]);
  if (flexCount === 1) {
    slots.push({
      key: "FLEX",
      label: "FLEX (WR/RB/TE)",
      eligible: ["RB", "WR", "TE"],
      rowTint: null,
    });
  } else {
    pushPositionSlots(slots, "FLEX", "FLEX", flexCount, ["RB", "WR", "TE"]);
  }

  if (flexSilver >= 1) {
    slots.push({
      key: "FLEX_SILVER",
      label: "FLEX of Silver (WR/RB/TE)",
      eligible: ["RB", "WR", "TE"],
      rowTint: "silver",
    });
  }
  if (flexGold >= 1) {
    slots.push({
      key: "FLEX_GOLD",
      label: "FLEX of Gold (WR/RB/TE)",
      eligible: ["RB", "WR", "TE"],
      rowTint: "gold",
    });
  }
  if (kCount === 1) {
    slots.push({ key: "K1", label: "K", eligible: ["K"], rowTint: null });
  } else {
    for (let i = 1; i <= kCount; i++) {
      slots.push({ key: `K${i}`, label: `K${i}`, eligible: ["K"], rowTint: null });
    }
  }
  return slots;
}

export function getStarterSlotKeys(settings) {
  return getStarterSlotDefinitions(settings).map((s) => s.key);
}

/** Multiplier applied to base weekly fantasy points for the team total (after stats). */
export function starterSlotFantasyMultiplier(slotKey) {
  if (slotKey === "FLEX_SILVER") return 1.5;
  if (slotKey === "FLEX_GOLD") return 2.0;
  return 1.0;
}

export function starterSlotRowStyle(rowTint) {
  if (rowTint === "silver") {
    return {
      background: "linear-gradient(90deg, #f1f5f9 0%, #e2e8f0 50%, #cbd5e1 100%)",
      color: "#334155",
      borderLeft: "4px solid #94a3b8",
    };
  }
  if (rowTint === "gold") {
    return {
      background: "linear-gradient(90deg, #fffbeb 0%, #fef3c7 50%, #fde68a 100%)",
      color: "#78350f",
      borderLeft: "4px solid #d97706",
    };
  }
  return {};
}
